import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import API_URL from "../config/config";
import "../css/editProfile.css";

function EditProfile() {

  const navigate = useNavigate();

  const userId = localStorage.getItem("user_id");

  const [form, setForm] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone: ""
  });

  useEffect(() => {

    axios
      .get(`${API_URL}/profile/${userId}`)
      .then((res) => {

        setForm(res.data);

      })
      .catch((err) => {

        console.log(err);

      });

  }, [userId]);

  const handleChange = (e) => {

    setForm({
      ...form,
      [e.target.name]: e.target.value
    });

  };

  const handleSubmit = async (e) => {

    e.preventDefault();

    try {

      const res = await axios.put(
        `${API_URL}/profile/${userId}`,
        form
      );

      alert(res.data.message);

      const user = JSON.parse(localStorage.getItem("user"));

      user.first_name = form.first_name;
      user.last_name = form.last_name;
      user.email = form.email;
      user.phone = form.phone;

      localStorage.setItem(
        "user",
        JSON.stringify(user)
      );

      navigate("/profile");

    } catch (err) {

      alert("Unable to update profile.");

    }

  };

  return (

    <div className="edit-profile-page">

      <div className="edit-profile-card">

        <h2>Edit Profile</h2>

        <form onSubmit={handleSubmit}>

          <input
            type="text"
            name="first_name"
            placeholder="First Name"
            value={form.first_name}
            onChange={handleChange}
            required
          />

          <input
            type="text"
            name="last_name"
            placeholder="Last Name"
            value={form.last_name}
            onChange={handleChange}
            required
          />

          <input
            type="email"
            name="email"
            placeholder="Email"
            value={form.email}
            onChange={handleChange}
            required
          />

          <input
            type="text"
            name="phone"
            placeholder="Phone"
            value={form.phone}
            onChange={handleChange}
          />

          <button type="submit">

            Save Changes

          </button>

        </form>

      </div>

    </div>

  );

}

export default EditProfile;